import {
  getInteractionSearchStrings,
  InteractionDefintion,
  SequenceSelectableDefinitions,
} from "../interaction_picker/InteractionDefinitions";
import useFilterableList from "../../hooks/useFilterableList";

/**
 * Thin adapter over {@link useFilterableList}. The matching, the highlight and
 * the ↑ ↓ / Enter / Escape keystrokes all live in the shared hook now; this
 * only pins it to the sequence-creatable definitions and keeps the option
 * naming the menu already uses.
 */
export default function useSequenceContextMenu(props: {
  onAddNode: (definition: InteractionDefintion) => void;
  onClose: () => void;
}) {
  const {
    filter,
    setFilter,
    filteredItems,
    selectedIndex,
    incrementIndex,
    reset,
    setOpen,
  } = useFilterableList<InteractionDefintion>({
    items: SequenceSelectableDefinitions,
    getSearchStrings: getInteractionSearchStrings,
    onSelect: props.onAddNode,
    onClose: props.onClose,
  });

  return {
    filter,
    setFilter,
    filteredOptions: filteredItems,
    selectedIndex,
    incrementIndex,
    reset,
    setOpen,
  };
}
